// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"FiltersModal_paginationPageDropdownWrap__Ik5yf","modal":"FiltersModal_modal__mbvcV","showResultsButton":"FiltersModal_showResultsButton__3LD6q"};